<div class="container">
  <div class="form-wizard-container">
    @if (isVenueUser) {
      <ng-container *ngTemplateOutlet="venueUserRequest"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="venueRequestForm"></ng-container>
    }
  </div>
</div>

<ng-template #venueRequestForm>
  <app-venue-request-wizard
    (afterSubmit)="onAfterSubmit()"
    [config]="venueRequestWizardConfig"
  ></app-venue-request-wizard>
</ng-template>

<ng-template #venueUserRequest>
  <div class="how-it-works-standalone">
    <div class="form-title">
      <span class="form-title-copy">Adding a new venue or room? We've got you.</span>
    </div>
    <div class="content">
      <div class="section-header">
        <span class="section-header-copy">How It Works</span>
      </div>
      <div class="step-content">
        <app-multi-step-instructions-carousel [steps]="howItWorksStepsVenueUser"></app-multi-step-instructions-carousel>
      </div>
    </div>
    <div class="footer">
      <div class="right">
        <div class="actions">
          <ts-button
            text="Get Started"
            color="primary"
            (click)="onGetStartedVenueUserClick()"
          ></ts-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
